import { injectIntl } from "react-intl";

import ScoreEditor from "./ScoreEditor";

export default injectIntl(ScoreEditor);
